import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const MobileBottomNav = ({ onGoHome }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('home');
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      // Only show when the user is at/near the very top of the page
      if (window.scrollY <= 50) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    handleScroll();

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith('/area') || path === '/all-areas' || path === '/areas') {
      setActiveTab('areas');
    } else if (path.startsWith('/property') || path === '/all-listings' || path === '/listings') {
      setActiveTab('listings');
    } else if (path === '/') {
      // Default to home if no hash section is selected
      if (!location.hash) {
        setActiveTab('home');
      }
    }
  }, [location.pathname, location.hash]);

  const handleNavClick = (e, tabKey, targetPath, hash) => {
    e.preventDefault();
    setActiveTab(tabKey);

    if (targetPath) {
      navigate(targetPath);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    if (location.pathname !== '/') {
      navigate('/');
    }

    if (hash && hash !== '#home') {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className={`mobile-bottom-nav ${isVisible ? '' : 'nav-hidden'}`}>
      <div className="mobile-bottom-nav-container">
        <a 
          href="#home" 
          onClick={(e) => handleNavClick(e, 'home', null, '#home')} 
          className={`mobile-nav-item ${activeTab === 'home' ? 'active' : ''}`}
        >
          <i className="bi bi-house-door-fill"></i>
          <span>Home</span>
        </a>

        <a 
          href="/all-areas" 
          onClick={(e) => handleNavClick(e, 'areas', '/all-areas')} 
          className={`mobile-nav-item ${activeTab === 'areas' ? 'active' : ''}`}
        >
          <i className="bi bi-geo-alt-fill"></i>
          <span>Areas</span>
        </a>

        <a 
          href="/all-listings" 
          onClick={(e) => handleNavClick(e, 'listings', '/all-listings')} 
          className={`mobile-nav-item ${activeTab === 'listings' ? 'active' : ''}`}
        >
          <i className="bi bi-building"></i>
          <span>Listings</span>
        </a>

        <a 
          href="#new-launch" 
          onClick={(e) => handleNavClick(e, 'projects', null, '#new-launch')} 
          className={`mobile-nav-item ${activeTab === 'projects' ? 'active' : ''}`}
        >
          <i className="bi bi-rocket-takeoff-fill"></i>
          <span>Projects</span>
        </a>

        <a 
          href="#contact" 
          onClick={(e) => handleNavClick(e, 'contact', null, '#contact')} 
          className={`mobile-nav-item ${activeTab === 'contact' ? 'active' : ''}`}
        >
          <i className="bi bi-telephone-fill"></i>
          <span>Contact</span>
        </a>
      </div>
    </div>
  );
};

export default MobileBottomNav;
